/**
 * iOS platform files
 */

export {default as commands} from './commands';
export {projectConfig, dependencyConfig, findPodfilePaths} from './config';
export {default as getArchitecture} from './tools/getArchitecture';
export {default as installPods} from './tools/installPods';
